<template>
  <div class="card height-equal-2">
    <div class="card-header card-no-border pb-0">
      <h3 class="mb-3">Drivers</h3>

      <ul class="nav nav-tabs justify-content-evenly" id="icon-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active text-success" id="available-drivers-tab" data-bs-toggle="tab"
             href="#available-drivers" role="tab" aria-controls="available-drivers" aria-selected="true">
            <i class="fa-regular fa-circle-check"></i>
            Available
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-warning" id="in-progress-drivers-tab" data-bs-toggle="tab"
             href="#in-progress-drivers" role="tab" aria-controls="in-progress-drivers" aria-selected="false">
            <i class="fa-solid fa-spinner"></i>
            In Progress
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-danger" id="unavailable-drivers-tab" data-bs-toggle="tab"
             href="#unavailable-drivers" role="tab" aria-controls="unavailable-drivers" aria-selected="false">
            <i class="fa-solid fa-ban"></i>
            Unavailable
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-primary" id="all-drivers-tab" data-bs-toggle="tab"
             href="#all-drivers" role="tab" aria-controls="all-drivers" aria-selected="false">
            <i class="fa-solid fa-list"></i>
            All
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content" id="icon-tabContent">
        <div class="tab-pane fade show active" id="available-drivers" role="tabpanel" aria-labelledby="icon-home-tab">
          <DataTable
              :ajax="{ url: availableDriversUrl}"
              ref="availableDriversTable" class="table-responsive display" :columns="availableColumns" />
        </div>

        <div class="tab-pane fade" id="in-progress-drivers" role="tabpanel" aria-labelledby="profile-icon-tabs">
          <DataTable
              :ajax="{ url: onRideDriversUrl}"
              ref="inProgressDriversTable" class="table-responsive display" :columns="onRideColumns" />
        </div>

        <div class="tab-pane fade" id="unavailable-drivers" role="tabpanel" aria-labelledby="contact-icon-tab">
          <DataTable
              :ajax="{ url: unavailableDriversUrl}"
              ref="unavailableDriversTable" class="table-responsive display" :columns="unavailableColumns" />
        </div>

        <div class="tab-pane fade" id="all-drivers" role="tabpanel" aria-labelledby="contact-icon-tab">
          <DataTable
              :ajax="{ url: allDriversUrl}"
              ref="allDriversTable" class="table-responsive display" :columns="allColumns" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {findDriverOnMapCTA, zonedDateTime} from '../utility/DatatableRenderer';

DataTable.use(DataTablesCore);

const props = defineProps({
  serviceProviderId: { type: String, required: true },
});

const emit = defineEmits(['drawDriverOnMap']);

//Url params for datatables
const allDriversUrl = `/api/datatable/sp-all-drivers/${props.serviceProviderId}`;
const availableDriversUrl = `${allDriversUrl}?status=AVAILABLE`;
const onRideDriversUrl = `${allDriversUrl}?status=ON_RIDE`
const unavailableDriversUrl = `${allDriversUrl}?status=OFFLINE`


//refs
const availableDriversTable = ref(null);
const inProgressDriversTable = ref(null);
const unavailableDriversTable = ref(null);
const allDriversTable = ref(null);

const findOnMapAction = (row) => {
  emit('drawDriverOnMap', row);
};

// Define columns
const availableColumns = [
  {data: "name", title: 'Driver Name'},
  {data: "vehicleType", title: 'Vehicle'},
  {title: 'Actions', orderable: false, searchable: false, render:  (data, type, row, meta) => {
        return findDriverOnMapCTA(data, type, row, meta, findOnMapAction);
      }}
];


const onRideColumns = [
  {data: "name", title:'Driver Name'},
  {data: "vehicleType", title:'Vehicle Details'},
  // {data: "eta", title:'ETA'},
  // {data: "pickupLocation", title:'Pickup Location'},
  // {data: "destination", title: 'Destination'}
];

const unavailableColumns = [
  {data: "name", title: 'Driver Name'},
  {data: "statusChangedOn", title: 'Last Active', render: zonedDateTime}
];

const allColumns = [
  {data: "name", title:'Driver Name'},
  {data: "vehicleType", title:'Vehicle'},
  {data: "driverStatus", title:'Status'},
];

</script>

